'use client';

import { useCallback, useEffect, useRef } from 'react';
import type { UxpTrackingEventPayload } from '@frameio/graphql-client/generated';
import {
  useGetBufferedUxpTrackingEventsLazyQuery,
  useTrackUxpEventSubscription,
} from '@frameio/shared/integrations/gql';
import { useTrack } from '@frameio/shared/segment/hooks';
import type { TrackingEventName } from '@frameio/shared/segment/hooks/types';

export const TrackUXPEvents = () => {
  const [getBufferedUxpTrackingEvents] =
    useGetBufferedUxpTrackingEventsLazyQuery({
      context: { resolveWithUXP: true },
    });
  const hasRequestedBufferedEvents = useRef(false);

  const track = useTrack();

  const handleEvent = useCallback(
    (event: UxpTrackingEventPayload) => {
      const payload = JSON.parse(event.payload) as Record<string, unknown>;
      const options = JSON.parse(event.options) as Record<string, unknown>;
      track(event.event as TrackingEventName, payload, options);
    },
    [track]
  );

  useEffect(() => {
    async function fetchData() {
      hasRequestedBufferedEvents.current = true;
      const { data } = await getBufferedUxpTrackingEvents();
      data?.getBufferedUxpTrackingEvents?.forEach(handleEvent);
    }
    if (!hasRequestedBufferedEvents.current) {
      fetchData();
    }
  }, [getBufferedUxpTrackingEvents, handleEvent]);

  useTrackUxpEventSubscription({
    onData: ({ data }) => {
      const event = data?.data?.uxpTrackingEvent;
      if (event) {
        handleEvent(event);
      }
    },
    context: {
      resolveWithUXP: true,
    },
  });

  return null;
};
